import { APP_CONST } from '../../constants/app-constants';
var routeLinks = APP_CONST.ROUTES_ACCOUNTS;

export const SideBarConfigs: any = {
  'account': [
    { title: APP_CONST.TITLE_HOME, tabKey: 'home', icon: "assets/images/icons.svg#home", activeIcon: "assets/images/icons.svg#homeActive", path: routeLinks.home, opacity: 0.5, },
    { title: APP_CONST.TITLE_SCORES, tabKey: 'scores', icon: "assets/images/icons.svg#speedometer", activeIcon: "assets/images/icons.svg#scoreActive", path: routeLinks.scores, labelRight: "15 mins" },
    { title: APP_CONST.TITLE_INBOX, tabKey: 'inbox', icon: "assets/images/icons.svg#all-Inbox", activeIcon: "assets/images/icons.svg#inboxActive", path: routeLinks.inbox, labelRight: "Real-time" },
    { title: APP_CONST.TITLE_ENGAGEMENT, tabKey: 'engagement', icon: "assets/images/icons.svg#engagement", activeIcon: "assets/images/icons.svg#engagementActive", path: routeLinks.engagement, labelRight: "Upto 48 hours" },
    { title: APP_CONST.TITLE_RELATIONSHIP_VIEW, tabKey: 'relationship', icon: "assets/images/icons.svg#relationship", activeIcon: "assets/images/icons.svg#relationshipActive", path: 'relationship', opacity: 0.5, },
  ],
  'project': [
    { title: APP_CONST.TITLE_SCORES, tabKey: 'scores', icon: "assets/images/icons.svg#speedometer", activeIcon: "assets/images/icons.svg#scoreActive", path: routeLinks.scores, labelRight: "15 mins" },
    { title: APP_CONST.TITLE_INBOX, tabKey: 'inbox', icon: "assets/images/icons.svg#projectInbox", activeIcon: "assets/images/icons.svg#projectInboxActive", path: routeLinks.inbox, labelRight: "Real-time" },
    { title: APP_CONST.TITLE_OUTBOX, tabKey: 'sent_beta', icon: "assets/images/icons.svg#outbox", activeIcon: "assets/images/icons.svg#outboxActive", path: routeLinks.outbox, labelRight: "Beta" },
    { title: APP_CONST.TITLE_ENGAGEMENT, tabKey: 'engagement', icon: "assets/images/icons.svg#engagement", activeIcon: "assets/images/icons.svg#engagementActive", path: routeLinks.engagement, labelRight: "Upto 48 hours" },
    { title: APP_CONST.TITLE_SENTIMENT_ANALYSIS, tabKey: 'sentiment_analysis', icon: "assets/images/icons.svg#engagement", activeIcon: "assets/images/icons.svg#engagementActive", path: routeLinks.sentimentAnalysis, labelRight: "" },
  ],
  'huddleMenu': { title: APP_CONST.TITLE_HUDDLE, tabKey: 'huddle', icon: "assets/images/icons.svg#Huddle", activeIcon: "assets/images/icons.svg#HuddleActive", path: routeLinks.huddle, },
  'actionMenu': { title: APP_CONST.TITLE_ACTION, tabKey: 'action_summary_v2', icon: "assets/images/icons.svg#action", activeIcon: "assets/images/icons.svg#ActionActive", path: routeLinks.action, labelRight: "15 mins" },
  "quickSightMenu":{ title: APP_CONST.TITLE_QUICK_SIGHT, tabKey: 'quick_sight', icon: "assets/images/icons.svg#quickSight", activeIcon: "assets/images/icons.svg#quickSight", labelRight: "" },
  'accountSetting': {
    "title": "Settings",
    "tabKey": "settings",
    "icon": "assets/images/icons.svg#settings",
    "activeIcon": "assets/images/icons.svg#settingActive",
    "path": "settings/general",
    'submenu': [
      // { title: APP_CONST.SUBMENU_TITLE_GENERAL, path: "settings/general" },
      { title: APP_CONST.SUBMENU_TITLE_PROJECTS, path: "settings/project" },
      // {
      //   title: APP_CONST.SUBMENU_TITLE_SUB_ACCOUNT,
      //   // path: "settings/sub-accounts",
      //   submenu: [
      //     {
      //       title: APP_CONST.SUB_ACCOUNT_SUBMENU_TITLE_NOTIFICATIONS,
      //       path: "settings/sub-accounts/notification",
      //     },
      //   ],
      // },
      { title: APP_CONST.SUBMENU_TITLE_USER_ACCESS, path: "settings/user-access" },
      // { title: APP_CONST.SUBMENU_TITLE_CONFIGURE_DASHBOARD, path: "settings/configure-dashboard" },
      // { title: APP_CONST.SUBMENU_TITLE_SECURITY, path: "settings/security" },
      // { title: APP_CONST.SUBMENU_TITLE_NOTIFICATION, path: "settings/notification" }
    ]
  },
  'projectSetting': {
    "title": "Settings",
    "tabKey": "settings",
    "icon": "assets/images/icons.svg#settings",
    "activeIcon": "assets/images/icons.svg#settingActive",
    "path": "settings",
    'submenu': [
      // { title: APP_CONST.SUBMENU_TITLE_PROJECTS, path: "settings/general" },
      { title: APP_CONST.SUBMENU_TITLE_CONVERSATION, path: "settings/interaction" },
      { title: APP_CONST.SUBMENU_TITLE_CHANNELS, path: "settings/channels" },
      { title: APP_CONST.SUBMENU_TITLE_ORGANISATION, path: "settings/organisation" },
      // { title: APP_CONST.SUBMENU_TITLE_REQUEST, path: "settings/request" },
      { title: APP_CONST.SUBMENU_TITLE_ACTION, path: "settings/action" },
      // { title: APP_CONST.SUBMENU_TITLE_DATASETS, path: "settings/datasets" }
      // { title: APP_CONST.SUBMENU_TITLE_ACTION, path: "settings/action" },
      { title: APP_CONST.SUBMENU_TITLE_DATASETS, path: "settings/datasets" },
      { title: APP_CONST.SUBMENU_TITLE_TOOLS, path: "settings/tools" },
    ]
  }
}


export const FirstTabConfigs: any = {
  account: {
    scores: {
      "summary_v2": "trends",
      "comparison": "details",
      "overview": "overview"
    },
    inbox: {
      "received": "all_responses",
      "verbatim": "verbatim"
    },
    engagement: {
      "summary": "lite",
      "summary_v2": "pro",
      "comparison_v2": "details"
    }
  },
  project: {
    scores: {
      "leaderboard": "quickinsights",
      "summary": "trends",
      "interaction": "questions",
      "comparison": "comparison"
    },
    inbox: {
      "received": "customer_feedback",
      "verbatim": "verbatim",
      "wordcloud": "wordcloud"
    },
    engagement: {
      "summary": "lite",
      "summary_v2": "pro",
      "comparison_v2": "details",
      "page_view_v2": "pageview"
    },
    action_summary_v2: {
      "count": "status_overview",
      "ageing": "open_actionables",
      "tat": "closed_actionables"
    },
    huddle: {
      "summary": "summary",
      "all_meetings": "all-huddles",
      "all_employee_spotlights": "all-spotlights",
      "all_action_plan": "all-action-plans",
      "all_process_improvements": "all-suggestions"
    },
    /** Sentiment Analysis: main tabs + `feed_link_redirect` / `cohort_footer` for Customer Feedback UI. */
    sentiment_analysis: {
      "overview": "overview",
      "details": "details",
      "summary": "trends",
      "feed_link_redirect": "feed_link_redirect",
      "cohort_footer": "cohort_footer"
    }
  }
}